// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__26fbJ","balanceDisclaimer":"posDashboard_balanceDisclaimer__1_u8M"};